module.exports = __webpack_public_path__ + "static/media/bgHomePage.613ef44e.jpg";